import React from "react";

export default ({ image }) => <img alt={image.alt} className="lazyload" src={image.src} data-srcset={image.srcset} />